import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">⌨ Key<span>Test</span></Link>
          <p>The most accurate free online keyboard and mouse testing tool. Diagnose issues instantly — no download needed.</p>
        </div>
        <div className="footer-links">
          <h4>Navigation</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/mouse-tester">Mouse Tester</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
          </ul>
        </div>
        <div className="footer-links">
          <h4>Tools</h4>
          <ul>
            <li><Link to="/">Keyboard Tester</Link></li>
            <li><Link to="/mouse-tester">Mouse Button Test</Link></li>
            <li><Link to="/mouse-tester">DPI Estimator</Link></li>
            <li><Link to="/#faq">Keyboard FAQ</Link></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} KeyTest. All rights reserved.</p>
        <Link to="/privacy-policy">Privacy Policy</Link>
      </div>
    </footer>
  );
}
